import { render, staticRenderFns } from "./ConfigForm.vue?vue&type=template&id=e67ddbd0&scoped=true"
import script from "./ConfigForm.vue?vue&type=script&lang=js"
export * from "./ConfigForm.vue?vue&type=script&lang=js"
import style0 from "./ConfigForm.vue?vue&type=style&index=0&id=e67ddbd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e67ddbd0",
  null
  
)

export default component.exports